// extracted by mini-css-extract-plugin
export var footer = "_r5-0";
export var inherit = "_r5-1";
export var input = "_r5-2";
export var modalContent = "_r5-3";
export var quillEditor = "_r5-4";
export var subtitle = "_r5-5";